import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TransferTokenRequest, MexicanTokenRequest } from '@kushki/js/lib/types/remote/transfer_token_request';
import { environment } from 'src/environments/environment';
import { KushkiTransferSubscriptionTokenRequestShared } from '../models/interface/kuhskiTransferSubscriptionToken.interface';
import { KushkiTransferTokenRequestShared } from '../models/interface/kuhskiTransferToken.interface';
import { RechargeDataShared } from '../models/interface/rechargeData.interface';
import { FormControlValidatorService } from './form-control-validator.service';
import { MuToastService } from './mu-toast.service';

@Injectable({
  providedIn: 'root',
})
export class MuCreditWireTransferTypeService {
  constructor(private formBuilder: UntypedFormBuilder, private validator: FormControlValidatorService) {
    /** */
  }

  /**
   *
   * @param {FormGroup} formData
   * @param {UserDataShared} userData
   * @param {ItemNumberToFilterShared[]} documentTypeList
   * @param {rechargeData} rechargeData
   * @returns
   */
  getCreditWireTransfer(formData: UntypedFormGroup): KushkiTransferSubscriptionTokenRequestShared {
    return {
      email: formData.get('emailWireTransfer').value,
    };
  }

  getCreditTransfer(formData: UntypedFormGroup, rechargeData: RechargeDataShared): KushkiTransferTokenRequestShared {
    const iva = rechargeData?.rechargeValue * rechargeData?.ivaPercentage;
    const subTotal = rechargeData?.rechargeValue + iva;
    return {
      currency: 'MXN',
      email: formData.get('emailWireTransfer').value,
      amount: {
        subtotalIva: 0,
        subtotalIva0: rechargeData?.rechargeValue,
        iva: 0,
      },
    };
  }

  /**
   * show toast register wire transfer
   * @param {MuToastService} muToastSerivice
   * @param {success} success
   * @param {Error} error
   */
  showToastRegisterWireTransfer(muToastService: MuToastService, success: boolean, error?: Error): void {
    muToastService.showSpecificToast({
      exception: error,
      key: 'toast-sidebar',
      severity: success ? 'success' : 'error',
      summary: 'toast.payment.' + (success ? 'success' : 'error') + '.registerWireTransfer.title',
      detail: 'toast.payment.' + (success ? 'success' : 'error') + '.registerWireTransfer.text',
      life: environment.toastData.life,
    });
  }

  /**
   * show toast copy board
   * @param {MuToastService} muToastSerivice
   * @param {success} success
   * @param {Error} error
   */
  showToastCopyBoard(muToastService: MuToastService, success: boolean, error?: Error): void {
    muToastService.showSpecificToast({
      exception: error,
      key: 'toast-sidebar',
      severity: success ? 'success' : 'error',
      summary: 'toast.payment.' + (success ? 'success' : 'error') + '.copyBoard.title',
      detail: 'toast.payment.' + (success ? 'success' : 'error') + '.copyBoard.text',
      life: environment.toastData.life,
    });
  }

  /**
   * get form data
   * @returns {FormGroup} response
   */
  getFormData(): UntypedFormGroup {
    return this.formBuilder.group({
      isInvalidForm: true,
      emailWireTransfer: ['', [Validators.required, this.validator.isValidEmail()]],
    });
  }
}
